import { Box, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { stringify } from 'query-string';
import React from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { ArrayParam, StringParam, useQueryParams } from 'use-query-params';
import { AlertCard, getAlertCardColors } from '../../../../../../common/cards/alert-card/AlertCard';
import { useVolDashboardMyElementsContext } from '../../VolDashboardMyElementsContext';

export const SideBarNewTasks = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const [query] = useQueryParams({
    activityStatus: ArrayParam,
    days: ArrayParam,
    startTime: StringParam,
    endTime: StringParam,
    startDate: StringParam,
    endDate: StringParam,
  });
  const { sidebarLoading, newTasksNumber, orgName } = useVolDashboardMyElementsContext();
  const { darkTextColor, lightTextColor } = getAlertCardColors('warning');

  return sidebarLoading ? (
    <Skeleton variant='text' width='100%' height={105} style={{ paddingBottom: '24px' }} />
  ) : newTasksNumber > 0 && orgName ? (
    <Box
      paddingBottom={3}
      width='100%'
      onClick={() => {
        history.replace(`${match.path}/?${stringify(query)}&tab=tasks`);
      }}
    >
      <AlertCard title='New Task' variant='warning'>
        <Typography
          variant='subtitle2'
          display='inline'
          style={{ fontSize: '14px', fontWeight: 400, color: lightTextColor }}
        >
          <span style={{ fontWeight: 'bold', color: darkTextColor }}>{newTasksNumber}</span>{' '}
          {`new tasks added by ${orgName} to complete. `}
        </Typography>

        <Typography
          variant='body2'
          display='inline'
          style={{ textDecoration: 'underline', color: darkTextColor, fontWeight: 700 }}
        >
          Click here
        </Typography>
        <Typography
          variant='subtitle2'
          display='inline'
          style={{ fontSize: '14px', fontWeight: 400, color: lightTextColor }}
        >
          {' to see.'}
        </Typography>
      </AlertCard>
    </Box>
  ) : null;
};
